<template lang="pug">
div
  div.m-hd
    .m-topBar
      //- a.goback(@click="$router.go(-1)") {{locale.goback}}
      a.w-button.w-button-block.btn-comment.kefu(href="javascript:;")
        | {{locale.kefu}} 
        i.u-icon.u-icon-detail-kefu(style="margin-left: 8px")
  .explain
    h1 {{locale.success}}
    order-note(:lang="language.name")

  .this_box
      .m-orderItem
          .row-1(style="padding-bottom: 0;")
              div(style="width: 50%;float: left")
                  .tips_orderid {{locale.orderTime}}
                  div(style="font-size: 12px;color: #666;") {{created_at}}

              div(style="width: 50%;float: left")
                  div(class="tips_orderid") {{locale.orderId}}
                  div(style="font-size: 12px;color: #666")
                    | {{order_no}}

          div.this_explain
              h2 {{locale.shouhuo}}
              p {{province}} {{city}} {{district}} {{address}}
              p {{name}}  &nbsp;&nbsp;&nbsp;{{mobile}}

          div(style="border-bottom: 1px solid #eee;margin: 20px 0;width: 93%;")
          .row-2
            div.goodImg.f-fl
              img(:src="wrapImageDomain(sg_order_items[0].sku_image)" width="64" height="64")
            div.goodInfo.f-fl
              div.goodName {{package_name}}
                div.goodName(style="position: absolute;bottom: 5px;right: 16px;text-align: right;color: #666")
            div.goodStatus.f-fr(style="color: #666;font-size: 12px;")
              div
                span {{locale.packageNum}}
                span 1

      .m-goodItems(id="showComboProduct_content")
        div(style="padding:0 10px")
          .row-2(v-for="item of sg_order_items" :key="item.id" style="padding-top: 5px;padding-left: 36px;position:relative;")
            .goodImg.f-fl
              img(:src="wrapImageDomain(item.sku_image)" width="32" height="32" style=" border-radius: 4px;overflow: hidden;border: 1px solid #eee;")
            .goodInfo.f-fl.u3(style="width: 70%;margin-top: 0px;")
              .goodName(style="font-size:12px;color: #aaa;margin-left: 16px;")
                | {{item.skuAttrsStr}}
                div(style="position:absolute;right:6px; font-size: 12px;color: #666;text-align: right")
                  span 
                    | x 
                  span 
                    | 1
  .m-orderItem
    .row-2(style="padding-bottom: 50px;")
      div
        span.tips {{locale.payment}}
        span.tips2 {{(locale.paymentType[payment - 1] || {}).name}}
      div
          span.tips {{locale.totalPrice}}
          span.tips2
            | {{locale.unit}}{{total_price}}
      div
        span.tips {{locale.yunfei}}
        span.tips2
          | {{locale.unit}}0.00
      div
          span.tips {{locale.shifu}} :
          span.tips2(style="color: #ff5a5f;font-weight: bold;")
            | {{locale.unit}}{{total_price}}
      

  .timetips
    ul
      li
        img(src="/image/7day.png" alt="") 
        | {{locale.sevenDay}}
      li
        img(src="/image/huodao.png" alt="") 
        | {{locale.paymentType[0].name}}
</template>

<script>
import locale from '../assets/locale'
// 配置
import config from '../../local_env.json'

import axios from 'axios'

import OrderNote from './OrderNote'

import moment from 'moment'

export default {
  components: {
    OrderNote
  },
  data() {
    return {
      locale: {},
      language: {},
      address: '',
      city: "台北市",
      created_at: "2020-06-10T15:01:20.000Z",
      district: "信義區",
      email: "flashtd1@163.com",
      from: "下单",
      id_poi_area: 1,
      id_poi_product: 189,
      message: "",
      mobile: 18911192222,
      name: "lulu",
      order_no: "202006100189000040TW2OP",
      payment: 2,
      postal: "100000",
      province: "台湾",
      sg_area: {},
      sg_order_items: [],
      total_price: "1.00",
      package_name: '', // 套餐名称,
      package_image: '' // 套餐图片
    }
  },
  methods: {
    // 给url添加oss域名前缀
    wrapImageDomain(url) {
      return config.imageDomain + url
    },
  },
  async mounted() {
    
    let {id, order_no, lang} = this.$route.query
    // let id = this.$route.query.orderId
    // let order_no = this.$route.query

    // 获取语言列表
    let languageId = lang
    let langRes = await axios.get(`${config.api}classes/language/${languageId}`, {
      headers: config.headers
    })

    // 获取订单
    let params = {}
    if (id) {
      params.id = id
    }

    if (order_no) {
      params.order_no = order_no
    }
    let res = await axios.get(`${config.api}order/get`,{
      params,
      headers: config.headers
    })

    res.data.created_at = moment(res.data.created_at).format('YYYY-MM-DD HH:mm:ss')
    res.data.sg_order_items.map((item) => {
      // 处理订单详情
      item.sku_image = ''
      item.skuAttrsStr = item.sg_sku.sg_sku_attributes.reduce((result, attr) => {
        if (attr.image) {
          item.sku_image = attr.image
        }
        let alias = attr.sg_attribute_aliases.find((alias) => {
          return alias.id_poi_language == languageId
        })
        if (alias) {
          result.push(alias.name)
        }
        return result
      }, []).join(',')
      return item
    })
    this.locale = locale(res.data.sg_area.name, langRes.data.name)
    this.language = langRes.data

    for(let k in res.data) {
      this[k] = res.data[k]
    }
  }
};
</script>

<style lang="less" scoped>
@import "../style/result/reset.css";
@import "../style/result/page-success.css";


.notic_show_combo_product{font-size: 12px;text-align: center;font-weight: bold;}
.notic_show_combo_product span{display: inline-block;font-weight: bold;padding:5px;border-radius: 4px;background: #eee;color: #666;cursor: pointer;letter-spacing: 1px;width: 90%;margin: 10px 0;}
.notic_show_combo_product .iu:after{content: '';}
.notic_show_combo_product .uu:after{content: '';}
html {
  background-color: white;
}
</style>